import PropTypes from "prop-types"
import { connect } from "react-redux"

import { updateChoice } from "areas/product/store/actions"
import Image from "components/ui/image"

/**
 * Diamond initials
 * example product - JLUX56-P2
 *
 * @param {object} data - from choice-options.jsx
 * @param {object} selectedValue - from choice-options.jsx
 */
const InternalInitialOptions = ({
  data,
  images,
  options,
  selectedValues,
  setChoice,
}) => {
  return (
    <div className="mb-16 flex">
      {Object.keys(options).map((pref) => {
        const imgSrc = images[`${pref}_view`]
          ? images[`${pref}_view`].src
          : null
        return (
          <div className="pr-20 text-center last:pr-0" key={`initials-${pref}`}>
            <p className="text-12 mb-5">{data.options_display_labels[pref]}</p>
            <Image
              className="mb-5"
              height={imgSrc ? "500" : "2400"}
              src={
                imgSrc || require("images/product/diamond/diamond_setting.png")
              }
              style={{ height: "100px", width: "100px" }}
              width={imgSrc ? "500" : "2400"}
            />
            <select
              className="mt-10 block w-full bg-white focus:outline-none"
              data-cy={`product-wizard-options-signature-${pref}-${selectedValues[pref]}`}
              onChange={(e) => setChoice(pref, e)}
              value={selectedValues[pref] || options[pref][0].value}
            >
              <option value="">Select</option>
              {options[pref].map((initial) => (
                <option
                  key={`DiamondSide-${initial.value}`}
                  value={initial.value}
                >
                  {initial.value}
                </option>
              ))}
            </select>
          </div>
        )
      })}
    </div>
  )
}

InternalInitialOptions.propTypes = {
  data: PropTypes.object,
  images: PropTypes.object,
  options: PropTypes.object,
  selectedValues: PropTypes.object,
  setChoice: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    images: {
      ...state.wizard.images,
      ...state.previewImage.data.images,
    },
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setChoice: (pref, e) => {
      const val = e.target.value
      const cv = ownProps.data.options.find(
        (cv) => cv.value == val && cv.pref == pref
      )
      dispatch(updateChoice(pref, cv, true))
    },
  }
}

const InitialOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalInitialOptions)

export default InitialOptions
